import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class DeklaracijeService {
  constructor(private _http: HttpClient) {}

  dohvatiNaljepnice(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_naljepnice_za_palete', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPalete(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_naljepnice_za_palete', a)
      .pipe(map((res: any) => res));
  }

  dodajPaletu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dodavanje_nove_palete', a)
      .pipe(map((res: any) => res));
  }

  urediPaletu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'uredi_paletu', a)
      .pipe(map((res: any) => res));
  }

  obrisiPaletu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'obrisi_paletu', a)
      .pipe(map((res: any) => res));
  }

  oznacitiIspisaneNaljepnice(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'ispisane_naljepnice', a)
      .pipe(map((res: any) => res));
  }

  oznacitiIspisanuNaljepnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'ispisane_pojedinacne_naljepnice', a)
      .pipe(map((res: any) => res));
  }

  dohvatiNoveNaljepnice(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'provjera_barkoda', a)
      .pipe(map((res: any) => res));
  }

  spremiIzmjeneProizvoda(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'spremi_barkoda', a)
      .pipe(map((res: any) => res));
  }
}

